// extracted by css-extract-rspack-plugin
export default {"Box":"table-cell-module__Box__ip0aZ1h","StyledTableCell":"table-cell-module__StyledTableCell__RYEgEZJ"};